import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------
import { buscarFonteService } from "../../../services/buscarFonteService";

export const useBuscarFonte = (fetch: boolean) => {
  const [fontes, setFontes] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  // UseEffect necessário para buscar as Fonte
  useEffect(() => {
    const fetchLead = async () => {
      if (fetch) {
        setIsLoading(true);
        try {
          const data = await buscarFonteService();
          if (data) {
            const filtradas = data.filter(
              (item: any) => !/site/i.test(item.nome) // remove "site" em qualquer variação
            );
            setFontes(filtradas);
          } else {
            console.error("Dados não encontrados");
          }
        } catch (error) {
          console.error("Erro ao buscar fontes:", error);
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    fetchLead();
  }, [fetch]);

  return { fontes, isLoading };
};
